import { render, staticRenderFns } from "./DevCode.vue?vue&type=template&id=7b3b5d17&scoped=true"
import script from "./DevCode.vue?vue&type=script&lang=js"
export * from "./DevCode.vue?vue&type=script&lang=js"
import style0 from "./DevCode.vue?vue&type=style&index=0&id=7b3b5d17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3b5d17",
  null
  
)

export default component.exports